import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';

const ArrowDown: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    className={cn(`svg-icon--${icon}`, className)}
    width="32"
    height="32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={`${icon}-24`}
  >
    <path
      d="M5.502 0l5.501 4.952L10 6.066 5.502 2.018 1.003 6.066 0 4.952 5.502 0z"
      transform="translate(10.498 12.991) rotate(-180 5.502 3.033)"
      fill="#000"
      fillRule="nonzero"
      stroke="none"
      strokeWidth={1}
    />
  </svg>
);

export default ArrowDown;
